import React from 'react';
import { Box, Flex } from '@chakra-ui/react';
import { Routes, Route, Navigate } from 'react-router-dom';
import StudentCalendar from '../Student/StudentCalendar';
import StudentSideBar from '../Components/StudentSideBar';
import StudentProfile from '../Student/StudentProfile';
import PrivateContentLayout from '../Common/PrivateContentLayout';
import StudentBatches from '../Student/StudentBatches';
import StudentExams from '../Student/StudentExams';
import StudentReports from '../Student/StudentReports';
import StudentAttendance from '../Student/StudentAttendance';
import StudentAnnouncements from '../Student/StudentAnnouncements';
import StudentExamAttempts from '../Student/StudentExamAttempts';
import StudentAssignments from '../Student/StudentAssignments';
import PaymentInfo from '../Student/PaymentInfo';
import StudentScoreViewAttempt from '../Student/StudentScoreViewAttempt';
import StudentLessonViewer from '../Student/StudentLessonViewer';
import StudentSupportPage from '../Student/StudentSupport';



const StudentRouter = () => {

    return (
        <Box >
           {/* Sidebar with fixed width */}
           < StudentSideBar/>
          <PrivateContentLayout >
        
          {/* Main content area with flexible width */}
          <Box overflowY="auto">
            <Routes>
              <Route path="/" element={<Navigate to="student-calendar" />} />
              <Route path="student-calendar" element={<StudentCalendar />} />
              <Route path="student-profile" element={<StudentProfile />} />
              <Route path="student-batches" element={<StudentBatches />} />
              <Route path="student-batches/lesson" element={<StudentLessonViewer />} />
              <Route path="payment-info" element={<PaymentInfo />} />
              <Route path="student-assignments" element={<StudentAssignments />} />
              <Route path="student-exams" element={<StudentExams />} />
              <Route path="student-exam-attempts" element={<StudentExamAttempts />} />
              <Route path="student-exam-attempts/score-view-attempt/:exam_attempt_id" element={<StudentScoreViewAttempt />} />
              {/* <Route path="student-exams/exam-lobby/:exam_attempt_id" element={<StudentExamLobby />} /> */}
              {/* <Route path="/exam-window/:exam_attempt_id" element={<StudentExamLobbyStandalone />} /> */}
              <Route path="student-reports" element={<StudentReports />} />
              <Route path="student-attendance" element={<StudentAttendance />} />
              <Route path="student-announcements" element={<StudentAnnouncements />} />
              <Route path="student-support" element={<StudentSupportPage />} />
              
{/*               <Route path="change-password" element={<ChangePassword handleLogout={() => {}} />} />  */}
            </Routes>
          </Box>
          </PrivateContentLayout >
      </Box>
    );
  };

export default StudentRouter;
